import type { Address } from '@einwert/valuation-api-client'

import { Box, Stack } from '@mui/material'
import { assembleAssetTitle, joinDefinedStrings, ListCardInfo, tokens } from 'ComponentLibrary'
import Typography from 'ComponentLibrary/src/piazza/text/Typography/Typography'
import { TextWithEllipsis } from 'ComponentLibrary/src/piazza/text'

export const AddressInfoCell = ({ address, customer_asset_reference }: { address: Address; customer_asset_reference?: string }) => {
    const assetTitle = assembleAssetTitle(address)
    const addressLineTwo = joinDefinedStrings([address.zip, address.city])
    const stateAndCountry = joinDefinedStrings([address.state, address.country], ', ')

    return (
        <ListCardInfo style={{ width: '260px', gap: tokens.SizingSpacing025, justifyContent: 'center' }}>
            <Stack direction="column" maxWidth="100%" gap={tokens.SizingSpacingNone}>
                {customer_asset_reference && (
                    <Box height="16px">
                        <TextWithEllipsis
                            tooltipText={`[${customer_asset_reference}]`}
                            typographyProps={{ variant: 'headline5', color: tokens.ColorTextDefault }}
                        >
                            [{customer_asset_reference}]
                        </TextWithEllipsis>
                    </Box>
                )}
                <TextWithEllipsis tooltipText={assetTitle} typographyProps={{ variant: 'headline4', color: tokens.ColorTextBoldest }}>
                    {assetTitle}
                </TextWithEllipsis>
            </Stack>
            <Stack direction="column" gap={tokens.SizingSpacingNone}>
                <Box height="16px">
                    <Typography variant="textS" color={tokens.ColorTextDefault}>
                        {addressLineTwo}
                    </Typography>
                </Box>{' '}
                <Box height="16px">
                    <Typography variant="textS" color={tokens.ColorTextDefault}>
                        {stateAndCountry}
                    </Typography>
                </Box>
            </Stack>
        </ListCardInfo>
    )
}
